import React from 'react';
import PropTypes from 'prop-types';

const BagPageVMPView = ({ errLabel, vmpClickHandler }) => {
  const [errPart1 = '', errPart2 = ''] = errLabel && errLabel.split('##');
  return (
    <>
      {errPart1}
      <a href="/us/bag" onClick={vmpClickHandler}>
        click here
      </a>
      {errPart2}
    </>
  );
};

BagPageVMPView.propTypes = {
  errLabel: PropTypes.string.isRequired,
  vmpClickHandler: PropTypes.func.isRequired,
};

export default BagPageVMPView;
export { BagPageVMPView as BagPageVMPViewVanilla };
